import { map } from 'lodash/fp';
import React, { ComponentProps } from 'react';

import { FRAGMENTS } from '../../src/client/models/table-of-contents/constants';
import getCmsData from '../../src/client/cms/utils/get-cms-data';
import getShouldSkipClientSideRequest from '../../src/client/utils/get-should-skip-client-side-request';
import getTableOfContentsListByIdentifierQuery from '../../src/client/models/table-of-contents/utils/get-table-of-contents-list-by-identifier-query';
import PerkPage from '../../src/client/pages/perks/listing';
import setCacheControlHeader from '../utils/set-cache-control-header';
import useTableOfContents from '../../src/client/cms/utils/use-table-of-contents';

const PERKS_IDENTIFIER = 'perks-page';

const PerksLandingPage = ({ ...props }: ComponentProps<typeof PerkPage>) => {
  const shouldSkipClientQuery = getShouldSkipClientSideRequest();

  const { items: perksRaw, loading: arePerksLoading } = useTableOfContents({
    fragment: FRAGMENTS.PERKS,
    skip: shouldSkipClientQuery,
    slug: PERKS_IDENTIFIER,
  });

  if (shouldSkipClientQuery || arePerksLoading) {
    return <PerkPage {...props} />;
  }

  const perks = map('item', perksRaw);
  return <PerkPage perks={perks} />;
};

// @ts-expect-error - Automatic, Please fix when editing this file
export const getServerSideProps = async ({ res }) => {
  setCacheControlHeader(res);

  const perksTableOfContentsQuery = getTableOfContentsListByIdentifierQuery(FRAGMENTS.PERKS);

  const allPerks = await getCmsData(perksTableOfContentsQuery, { variables: { identifier: PERKS_IDENTIFIER } });

  return { props: { perks: map('item', allPerks?.allTableOfContentsList[0]?.items) } };
};

export default PerksLandingPage;
